import React from 'react'
import {
  Container,
  MeasurementContainer,
  Value,
  MeasurementsGroup,
  EmptyMeasurement,
  ItemContainer,
  CellContainer,
  MedicationUseTitle,
  MedicationUseValue
} from './styles'
import { Title } from './Title'
import { Tooltip } from '~/components/shared/tooltip'
import { EMPTY_MEASUREMENT_TEXT } from '~/constants/checkUp'
import { CheckUpPropertyMeasurement, ECheckUpPropertyTypes } from '~/interfaces'

interface MeasurementsProps {
  status: 'normal' | 'altered' | 'result'
  value: string
}

export const Measurements = ({ status, value }: MeasurementsProps): JSX.Element => {
  const removeEmptySpaces = (value: string): string => value.replaceAll(' ', '')
  return (
    <MeasurementContainer data-testid="measurement" status={status}>
      <Value>{removeEmptySpaces(value)}</Value>
    </MeasurementContainer>
  )
}

const renderMedicationUse = (type: ECheckUpPropertyTypes, medicationUse?: boolean): JSX.Element | null => {
  if (type === ECheckUpPropertyTypes.ARTERIAL_PRESSURE || type === ECheckUpPropertyTypes.GLYCEMIA) {
    const value = medicationUse === undefined ? 'N/A' : medicationUse === true ? 'SIM' : 'NÃO'

    return (
      <CellContainer medicationUse={medicationUse}>
        <MedicationUseTitle>
          {type === ECheckUpPropertyTypes.ARTERIAL_PRESSURE ? 'Anti-hipertensivo' : 'Anti-diabético'}
        </MedicationUseTitle>
        <MedicationUseValue medicationUse={medicationUse}>{value}</MedicationUseValue>
      </CellContainer>
    )
  } else return null
}

interface PropertyIndicatorsProps {
  property: CheckUpPropertyMeasurement[]
}

export const PropertyIndicators = ({ property }: PropertyIndicatorsProps): JSX.Element => {
  const { type, unit } = property[0]
  const propertySimulation = property?.find(property => property.simulationResult)?.simulationResult
  return (
    <Container>
      <Title type={type} unit={unit} />

      <MeasurementsGroup>
        {property?.map((measurement, index) => {
          if (measurement.value === EMPTY_MEASUREMENT_TEXT) {
            return (
              <Tooltip
                key={`${measurement.date}${index}`}
                opacity={0.8}
                description={'Não possui registro para este período'}
              >
                <ItemContainer>
                  <EmptyMeasurement>{EMPTY_MEASUREMENT_TEXT}</EmptyMeasurement>
                  {renderMedicationUse(type)}
                </ItemContainer>
              </Tooltip>
            )
          }

          return (
            <ItemContainer key={`${measurement.date}-${index}`}>
              <Measurements status={measurement.isAltered ? 'altered' : 'normal'} value={measurement.value} />
              {renderMedicationUse(type, measurement.medicationUse)}
            </ItemContainer>
          )
        })}
      </MeasurementsGroup>

      <Measurements status="result" value={`${propertySimulation}%`} />
    </Container>
  )
}
